module.exports = __webpack_public_path__ + "media/images/icons/filled/code-37996f74efe10755ec78c996e934b269.svg";